import {
  AirVent,
  Bath,
  CheckCircle2,
  Droplets,
  Gauge,
  Home,
  ShieldCheck,
  Wrench,
} from "lucide-react";

export const services = [
  {
    icon: Bath,
    title: "Domestic plumbing",
    description: "Careful installation and maintenance for bathrooms, kitchens and complete home plumbing systems.",
    details: ["Bathroom & kitchen plumbing", "Pipework installation", "Repairs & maintenance"],
    image: "/projects/ashford-the-triangle/first-fix.webp",
  },
  {
    icon: AirVent,
    title: "Domestic ventilation",
    description: "Well-planned ventilation that keeps homes fresh, comfortable and energy efficient throughout the year.",
    details: ["Extract ventilation", "Whole-home systems", "Airflow optimisation"],
    image: "/projects/fendall-street/risers.webp",
  },
];

export const values = [
  { icon: ShieldCheck, title: "Built with care", text: "Every detail is completed with pride, precision and respect for your home." },
  { icon: Gauge, title: "Performance first", text: "Systems are planned around reliable performance, comfort and long-term efficiency." },
  { icon: CheckCircle2, title: "Clear standards", text: "Straightforward communication and a clean, professional approach from start to finish." },
];

export const projects = [
  {
    title: "Ashford — The Triangle",
    category: "First fix plumbing",
    image: "/projects/ashford-the-triangle/first-fix.webp",
    className: "project-large",
    href: "/projects/ashford-the-triangle",
  },
  {
    title: "Kitchen & bathroom systems",
    category: "Second fix",
    image: "/projects/ashford-the-triangle/second-fix.webp",
    className: "project-tall",
    href: "/projects/ashford-the-triangle",
  },
  {
    title: "Tested & commissioned",
    category: "Commissioning",
    image: "/projects/ashford-the-triangle/commissioning.webp",
    className: "project-small",
    href: "/projects/ashford-the-triangle",
  },
];

export const ashfordProject = {
  title: "Ashford — The Triangle",
  location: "Ashford, Kent",
  client: "Vidi Construction",
  discipline: "Domestic plumbing",
  scope: "Complete plumbing systems for kitchens and bathrooms, from first fix and second fix through to testing and commissioning.",
  stages: ["Kitchen plumbing system", "Bathroom plumbing system", "First fix", "Second fix", "Testing & commissioning"],
  gallery: [
    { src: "/projects/ashford-the-triangle/first-fix.webp", alt: "Precision first fix copper pipework at The Triangle, Ashford", caption: "First fix pipework" },
    { src: "/projects/ashford-the-triangle/second-fix.webp", alt: "Second fix kitchen plumbing connections", caption: "Second fix connections" },
    { src: "/projects/ashford-the-triangle/commissioning.webp", alt: "Hot water and ventilation equipment ready for commissioning", caption: "System commissioning" },
    { src: "/projects/ashford-the-triangle/bathroom-finish.webp", alt: "Completed bathroom at The Triangle, Ashford", caption: "Bathroom completion" },
    { src: "/projects/ashford-the-triangle/kitchen-detail.webp", alt: "Completed kitchen sink and tap installation", caption: "Kitchen second fix" },
    { src: "/projects/ashford-the-triangle/kitchen-finish.webp", alt: "Completed kitchen at The Triangle, Ashford", caption: "Finished kitchen" },
  ],
};

export const stats = [
  { value: "2", label: "Core specialisms" },
  { value: "100%", label: "Attention to detail" },
  { value: "1", label: "Trusted point of contact" },
];

export const capabilities = [
  { icon: Droplets, text: "Water systems" },
  { icon: Wrench, text: "Mechanical fitting" },
  { icon: AirVent, text: "Fresh airflow" },
  { icon: Home, text: "Domestic projects" },
];

export const contactDetails = {
  contacts: [
    { name: "Catalin Negru", phone: "+44 7809 137579" },
    { name: "Iulian Afloarei", phone: "+44 7563 122548" },
  ],
  email: "Info@ncpmechanical.co.uk",
  location: "71–75 Shelton Street, Covent Garden, London, WC2H 9JQ",
  hours: "Monday–Friday, 08:00–17:30",
};